// src/pages/ThankYou.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { Result, Button } from "antd";

const ThankYou = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const type = queryParams.get("type") || "info"; // success | error | warning | info
  const message =
    queryParams.get("message") || "Thank you for completing the operation.";

  const statusMap = {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
      <Result
        status={statusMap[type] || "info"}
        title="Thank You!"
        subTitle={message}
        extra={
          <Button type="primary" href="/" style={{backgroundColor: "#0B2A1B",borderColor: "#0B2A1B"}}>
            Home
          </Button>
        }
      />
    </div>
  );
};

export default ThankYou;